<template>
    <div class="page-container flex flex-col justify-center">
        <div class="text-center">
            <img src="../../assets/image/exception/404.svg" alt />
        </div>
        <div class="text-center">
            <h1 style="color: #fff;font-size: 20px">抱歉，你访问的页面不存在</h1>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    }
}
</script>
<style lang="scss">
.page-container {
    width: 100%;
    padding: 50px 0;
    height: 100vh;
    border-radius: 4px;
    .text-center {
        h1 {
            color: #666;
            padding: 20px 0;
        }
    }

    img {
        width: 350px;
        margin: 0 auto;
    }
}
</style>